// src/pages/public/Terms.jsx
// FASE 2.B — P-03 Términos y condiciones (pixel-perfect del mockup v4).
// Source: entregable_claude/screens_public.jsx líneas 25-74.
// La prop `go` del mockup se convierte a useNavigate(); go("landing_c") → navigate('/').
import { Helmet } from 'react-helmet-async';
import { PubHead, LegalSection } from './_publicShared';
import { useSmartBack } from '../../auth/useSmartBack';

export default function Terms() {
  // FIX back-button: useSmartBack respeta history primero, y si entró
  // directo por URL cae al destino correcto según rol/acceso (dashboard
  // si activo, landing si no).
  const handleBack = useSmartBack();

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Términos y condiciones · Edge Elite</title>
        <meta name="description" content="Términos y condiciones de Edge Elite — plataforma chilena de análisis estadístico deportivo. Reglas de uso del servicio." />
        <link rel="canonical" href="https://edgeelite.cl/terminos" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Términos y condiciones · Edge Elite" />
        <meta property="og:url" content="https://edgeelite.cl/terminos" />
      </Helmet>

      <section className="screen" style={{ paddingTop: 28, paddingBottom: 60 }}>
        <PubHead back={handleBack} title="Términos y condiciones" />

        <div style={{ marginBottom: 24 }}>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: '-0.025em',
              margin: 0,
              marginBottom: 8,
            }}
          >
            Términos de servicio
          </h2>
          <div style={{ fontSize: 12, color: 'var(--muted)' }}>
            Última actualización: <span className="num">24 mayo 2026</span>
          </div>
        </div>

        <div
          style={{
            padding: 14,
            background: 'var(--accent-soft)',
            borderLeft: '3px solid var(--accent)',
            borderRadius: 8,
            fontSize: 12,
            color: '#7C2D0E',
            lineHeight: 1.5,
            marginBottom: 26,
          }}
        >
          <strong>Aviso importante:</strong> Edge Elite es una herramienta de análisis estadístico e
          información deportiva. No garantizamos resultados ni ganancias. Toda apuesta implica riesgo de
          pérdida económica. Servicio exclusivo para mayores de 18 años. Usa la información con
          responsabilidad.
        </div>

        <LegalSection n="1" title="Aceptación de los términos">
          Al usar Edge Elite, aceptas estos términos en su totalidad. Si no estás de acuerdo, no uses el
          servicio.
        </LegalSection>

        <LegalSection n="2" title="Descripción del servicio">
          Edge Elite es una plataforma de análisis estadístico e información deportiva sobre básquet.
          Nuestro modelo procesa datos en tiempo real y comparte análisis vía Telegram. Edge Elite no es
          una casa de apuestas ni gestiona apuestas: es una herramienta informativa. Cualquier decisión
          que tomes con base en nuestra información es de tu exclusiva responsabilidad.
        </LegalSection>

        <LegalSection n="3" title="Edad mínima">
          Debes tener al menos 18 años para usar Edge Elite. Al registrarte confirmas tu mayoría de edad
          según la ley chilena.
        </LegalSection>

        <LegalSection n="4" title="Suscripción y pagos">
          Edge Elite funciona mediante una suscripción de pago recurrente gestionada a través de
          Flow.cl. El plan disponible es mensual ($19.990 CLP). Al activar tu suscripción cuentas con
          5 días de prueba sin costo; este beneficio aplica únicamente a la suscripción, los pagos por
          otros medios no incluyen período de prueba. Si no cancelas antes de que termine la prueba, se
          cobra automáticamente el primer mes y la suscripción se renueva de forma automática cada mes.
          Al suscribirte autorizas estos cobros recurrentes sobre el medio de pago que registraste. Los
          montos ya cobrados no son reembolsables. Podemos actualizar el precio del plan avisándote con
          anticipación razonable.
        </LegalSection>

        <LegalSection n="5" title="Uso responsable">
          Edge Elite promueve el uso responsable y no fomenta el juego compulsivo. El servicio tiene
          fines informativos y es solo para mayores de 18 años. Juega siempre dentro de tus
          posibilidades.
        </LegalSection>

        <LegalSection n="6" title="Limitación de responsabilidad">
          Edge Elite entrega información y análisis sin garantía de resultados. No nos hacemos
          responsables por pérdidas económicas derivadas de decisiones de apuesta. La decisión final de
          apostar es siempre del usuario.
        </LegalSection>

        <LegalSection n="7" title="Cancelación">
          Puedes cancelar tu suscripción cuando quieras desde Mi cuenta, sin permanencia ni penalización.
          Al cancelar dejas de generar cobros futuros y conservas el acceso hasta el final del período ya
          pagado. No se realizan reembolsos por días no utilizados.
        </LegalSection>

        <div
          style={{
            marginTop: 32,
            paddingTop: 20,
            borderTop: '1px solid var(--line)',
            textAlign: 'center',
            fontSize: 13,
            color: 'var(--muted)',
          }}
        >
          contacto@edgeelite.cl
        </div>
      </section>
    </div>
  );
}
